module.exports = __webpack_public_path__ + "static/img/img3.3a5e8e3d.png";